import { DeleteTemplateMessage, DeleteTemplateMessageVariables } from './__generated__/DeleteTemplateMessage'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation DeleteTemplateMessage($input: DeleteTemplateMessageInputV2!) {
    deleteTemplateMessage: deleteTemplateMessageV2(input: $input) {
      ... on TemplateMessageV2 {
        id
        isFeatured
        attribution
        categoryId
        created
        message {
          id
          characters
          text
        }
      }
      ... on TemplateMessageErrorV2 {
        type
        error
      }
    }
  }
`

export const useDeleteTemplateMessage = () =>
  useMutation<DeleteTemplateMessage, DeleteTemplateMessageVariables>(MUTATION)
